import { z } from 'zod';

import { BASE_SCHEMAS } from './base';

export const tableSchema = z.object({
  number: BASE_SCHEMAS.requiredString({
    fieldName: 'Table number',
    minLength: 1,
    maxLength: 20,
  }),
  type: z.enum(['dining', 'bar', 'outdoor', 'private', 'booth', 'casual']),
  capacity: z
    .number()
    .int('Capacity must be a whole number')
    .min(1, 'Capacity must be at least 1')
    .max(50, 'Capacity must be at most 50'),
  description: z.string().max(200).optional(),
});

export type TableFormData = z.infer<typeof tableSchema>;

export const tableDefaultValues: TableFormData = {
  number: '',
  type: 'casual',
  capacity: 4,
  description: '',
};
